import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import { RouteObject } from 'react-router-dom'
import SurveyHome from './components'
import SurveyRecordCreate from './components/Survey/Create'
import SurveyRecordDetail from './components/Survey/Detail'

const SurveyModule: RouteObject = {
    path: 'surveys',
    children: [
        {
            path: '',
            element: <SurveyHome />,
        },
        // {
        //     path: 'new',
        //     element: <SurveyCreate />,
        // },
        {
            path: 'records/new',
            element: <SurveyRecordCreate />,
        },
        // {
        //     path: ':surveyId',
        //     element: <SurveyDetail />,
        // },
        {
            path: 'records/:recordId',
            element: <SurveyRecordDetail />,
        },
        // {
        //     path: ':surveyId/edit',
        //     element: <SurveyEdit />,
        // },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default SurveyModule
